<template>
  <Main>
    <v-container>
      <v-card class="mx-auto">
        <v-card-text>
          <p class="display-1 text--primary">
            Upload Incentive
            <v-btn small color="warning" @click="downloadCSV()">Download Template</v-btn>
          </p>
          <div class="text--primary">
            <!-- {{ this.SELECTED_MONTH_PERIOD + " - " + this.SELECTED_YEAR_PERIOD + " - " + this.SELECTED_BRANCH}} -->
            <!-- {{ this.VSELECT_BRANCH }} -->
            <v-row>
              <v-col md="12" sm="12">
                <!-- {{ "CSV : " + this.JSON_FILE_UPLOAD }} -->
                <FilePond
                  name="test"
                  ref="pond"
                  class-name="my-pond"
                  label-idle="Click or Drop files here..."
                  accepted-file-types="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv, application/csv"
                  :files="this.FILE_UPLOAD"
                  :init="handleFilePondInit"
                  v-on:updatefiles="handleFilePondUpdateFile"
                  v-on:removefile="handleFilePondRemoveFile"
                />
              </v-col>
              <v-col md="12" sm="12">
                <v-btn
                  small
                  color="warning"
                  class="mb-3 float-right"
                  @click="confirmModal(submitUpload)"
                  >Submit Uploaded File</v-btn
                >
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text
          >It will submit all data which is imported to database. Please give confirmation
          before you submit.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import XLSX from "xlsx";

// Import the plugin code
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";

// Import Vue FilePond
import vueFilePond, { setOptions } from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType);

setOptions({
  allowMultiple: false,
});

const JSON_FOR_DOWNLOAD = [
  {
    YEAR_ID: "",
    MONTH_ID: "",
    KODE_CABANG: "",
    PRODUCT_NAME: "",
    SUBLINI_OR_PRODUCT: "",
    CHANNEL_OUTLET_GROUP: "",
    SALESPERSON_POSITION: "",
    TERRITORY_GEO_GROUP: "",
    SUM_OF_TARGET_REKOMENDASI_HO: "",
    SUM_OF_TARGET_CABANG: "",
  },
];

export default {
  components: {
    Main,
    FilePond,
  },
  data() {
    return {
      methodAction: "",
      isOpenModalConfirm: false,
      FILE_UPLOAD: [],
      JSON_FILE_UPLOAD: [],
      search: "",
      dtLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      isLoading: false,
    };
  },
  methods: {
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    handleFilePondInit() {},
    handleFilePondUpdateFile(file) {
      let self = this;
      let counter = true;

      const UPLOADED_CSV = file.map((fileItems) => fileItems.file);

      var files = UPLOADED_CSV,
        f = files[0];

      if (f) {
        var reader = new FileReader();
        reader.onload = (e) => {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, { type: "array" });
          let sheetName = workbook.SheetNames[0];
          /* DO SOMETHING WITH workbook HERE */
          let worksheet = workbook.Sheets[sheetName];
          const XLSXJSON = XLSX.utils.sheet_to_json(worksheet);
          self.dtItems = [];
          if (self.dtItems < 1) {
            for (let XLSXJSONDATA of XLSXJSON) {
              if (
                XLSXJSONDATA.YEAR_ID != undefined &&
                XLSXJSONDATA.MONTH_ID != undefined &&
                XLSXJSONDATA.KODE_CABANG != undefined &&
                XLSXJSONDATA.PRODUCT_NAME != undefined &&
                XLSXJSONDATA.SUBLINI_OR_PRODUCT != undefined &&
                XLSXJSONDATA.CHANNEL_OUTLET_GROUP != undefined &&
                XLSXJSONDATA.SALESPERSON_POSITION != undefined &&
                XLSXJSONDATA.TERRITORY_GEO_GROUP != undefined &&
                XLSXJSONDATA.SUM_OF_TARGET_REKOMENDASI_HO != undefined &&
                XLSXJSONDATA.SUM_OF_TARGET_CABANG != undefined
              ) {
                self.dtItems.push({
                  TGT_YEAR_ID: XLSXJSONDATA.YEAR_ID,
                  TGT_MONTH_ID: XLSXJSONDATA.MONTH_ID,
                  BRANCH_CODE: XLSXJSONDATA.KODE_CABANG,
                  PRODUCT_NAME: XLSXJSONDATA.PRODUCT_NAME,
                  PRODUCT_SUB_LINE: XLSXJSONDATA.SUBLINI_OR_PRODUCT,
                  OUTLET_CHANNEL_GROUP: XLSXJSONDATA.CHANNEL_OUTLET_GROUP,
                  ROLE_POSITION_CODE: XLSXJSONDATA.SALESPERSON_POSITION,
                  TERITORY_GEO_GROUP: XLSXJSONDATA.TERRITORY_GEO_GROUP,
                  VALUE_TGT_HO: XLSXJSONDATA.SUM_OF_TARGET_REKOMENDASI_HO,
                  VALUE_TGT_CAB: XLSXJSONDATA.SUM_OF_TARGET_CABANG,
                });
              }
            }
          }

          // console.log(self.dtItems);
        };
        reader.readAsArrayBuffer(f);
      }
    },
    handleFilePondRemoveFile(error, file) {
      this.$refs.pond.removeFile();
      this.dtItems = [];
    },
    submitUpload() {
      if (this.dtItems.length > 0) {
        const USER_DATA = JSON.parse(localStorage.getItem("userData"));
        let data = {
          DATA_TARGET: this.dtItems,
          USER_ID: USER_DATA.USER_ID_UPDATE,
        };

        this.isLoading = true;
        this.isOpenModalConfirm = false;

        this.$http
          .post("/target/upload", data, {
            headers: {
              "api-key": this.$apiKey
            }
          })
          .then((res) => {
            console.log(res);
            const { success, message, data } = res.data;
            if (success) {
              this.isLoading = false;
              this.dtItems = [];
              this.$refs.pond.removeFile();
              this.showSnackbar("Import Data Success !");
            } else {
              this.isLoading = false;
              this.isOpenModalConfirm = false;
              this.showSnackbar(message);
            }
          })
          .catch((err) => {
            this.isLoading = false;
            this.isOpenModalConfirm = false;
            this.showSnackbar(err.toString());
          });
      } else {
        this.isLoading = false;
        this.isOpenModalConfirm = false;
        this.showSnackbar("Please Upload CSV File First !");
      }
    },
    downloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(JSON_FOR_DOWNLOAD);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Template Target.xlsx"); // initiate a file download in browser
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
  },
};
</script>
